<template>
  <a-card class="m-height-full m-display-flex flex-column nowrap w-head">
    <h3 class="margin-remove" slot="title">Human Resources</br> Development</h3>
    <a-menu
      class="m-menu-borderless"
      overflowedIndicator="Other"
      slot="extra"
      mode="horizontal"
      v-if="!getScreen && subNavigation.length > 0"
    >
      <template v-for="subNav in subNavigation[0].child">
        <a-menu-item :key="subNav.id_menu" v-if="subNav.child.length === 0">
          <router-link :to="subNav.link_menu">
            <a-icon :type="subNav.icon_menu" />
            {{subNav.label_menu}}
            &nbsp;
            <a-badge
              class="m-badge m-badge-small"
              :count="countNotif(subNav)"
              :numberStyle="{backgroundColor: 'red'}"
            ></a-badge>
          </router-link>
        </a-menu-item>
        <a-sub-menu :key="subNav.id_menu" v-else>
          <span slot="title">
            <a-icon :type="subNav.icon_menu" />
            <span>{{subNav.label_menu}}</span>
            &nbsp;
            <a-badge
              class="m-badge m-badge-small"
              :count="countNotif(subNav)"
              :numberStyle="{backgroundColor: 'red'}"
            ></a-badge>
          </span>

          <a-menu-item v-for="childmenu in subNav.child" :key="childmenu.id_menu">
            <router-link :to="childmenu.link_menu">
              <div class="m-display-flex space-between align-middle">
                <div>
                  <a-icon :type="childmenu.icon_menu" />
                  <span>{{childmenu.label_menu}}</span>
                </div>&nbsp;
                <a-badge
                  class="m-badge m-badge-small"
                  :count="childmenu.notif"
                  :numberStyle="{backgroundColor: 'red'}"
                ></a-badge>
              </div>
            </router-link>
          </a-menu-item>
        </a-sub-menu>
      </template>
    </a-menu>
    <a-popover
      placement="bottomRight"
      slot="extra"
      title="Menu HRD"
      trigger="click"
      v-model="visible"
      v-else-if="getScreen && subNavigation.length > 0"
    >
      <a-button type="default" icon="align-right"></a-button>
      <div slot="content">
        <a-menu class="m-menu-borderless" slot="extra" mode="inline">
          <template v-for="subNav in subNavigation[0].child">
            <a-menu-item :key="subNav.id_menu" v-if="subNav.child.length === 0">
              <router-link :to="subNav.link_menu">
                <a-icon :type="subNav.icon_menu" />
                {{subNav.label_menu}}
                &nbsp;
                <a-badge
                  class="m-badge m-badge-small"
                  :count="countNotif(subNav)"
                  :numberStyle="{backgroundColor: 'red'}"
                ></a-badge>
              </router-link>
            </a-menu-item>
            <a-sub-menu class="padding-remove" :key="subNav.id_menu" v-else>
              <span slot="title">
                <a-icon :type="subNav.icon_menu" />
                <span>{{subNav.label_menu}}</span>
                &nbsp;
                <a-badge
                  class="m-badge m-badge-small"
                  :count="countNotif(subNav)"
                  :numberStyle="{backgroundColor: 'red'}"
                ></a-badge>
              </span>

              <a-menu-item @click="hide" v-for="childmenu in subNav.child" :key="childmenu.id_menu">
                <router-link :to="childmenu.link_menu">
                  <div class="m-display-flex space-between align-middle">
                    <div>
                      <a-icon :type="childmenu.icon_menu" />
                      <span>{{childmenu.label_menu}}</span>
                    </div>&nbsp;
                    <a-badge
                      class="m-badge m-badge-small"
                      :count="childmenu.notif"
                      :numberStyle="{backgroundColor: 'red'}"
                    ></a-badge>
                  </div>
                </router-link>
              </a-menu-item>
            </a-sub-menu>
          </template>
        </a-menu>
      </div>
    </a-popover>
    <router-view v-bind="refPrnMenu"></router-view>
  </a-card>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import _ from "lodash";

export default {
  name: "Hrd",
  data() {
    return {
      visible: false,
      currentMenu: {},
      prnMenu: {},
    };
  },
  methods: {
    hide() {
      this.visible = false;
    },
    countNotif(menu) {
      let hitungNotif = 0;
      if (
        (this.getNavigation !== undefined || this.getNavigation !== null) &&
        menu !== undefined
      ) {
        if (menu.child.length > 0) {
          menu.child.forEach((element) => {
            if (element.notif !== "null" || element.notif !== null) {
              hitungNotif = hitungNotif + Number(element.notif);
            }
          });
        } else {
          if (menu.notif !== "null" || menu.notif !== null) {
            hitungNotif = hitungNotif + Number(menu.notif);
          }
        }
      }

      return hitungNotif;
    },
  },
  computed: {
    ...mapGetters(["getScreen", "getNavigation"]),
    refPrnMenu() {
      return {
        prnMenu: _.filter(
          this.getNavigation,
          nav =>
            nav.label_menu &&
            nav.label_menu.toLowerCase().indexOf("HRD".toLowerCase()) >= 0
        )
      };
    },
    subNavigation() {
      let subnav = [];
      if (
        this.getNavigation !== undefined ||
        this.getNavigation !== null ||
        this.getNavigation.length <= 0
      ) {
        subnav = _.filter(
          this.getNavigation,
          (nav) =>
            nav.label_menu &&
            nav.label_menu.toLowerCase().indexOf("HRD".toLowerCase()) >= 0
        );
      }
      return subnav;
    },
  },
};
</script>

<style scoped lang="less">
.ant-menu-submenu-title {
  padding-left: 0 !important;

}
</style>